/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */


(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        $('.bannernav li a').hover(function() {
          var newslide = $('.bannernav li a').index($(this));
              $('#mainslides').cycle('pause');
              $('#mainslides').cycle('goto', newslide);
            }, function() {
              $( this ).removeClass( "hover" );
            }
          );
        
        $( '#mainslides' ).on( 'cycle-update-view', function( event, opts ) {
            
            $('.bannernav li a').removeClass('active');
            $('.bannernav li a').eq(opts.currSlide).addClass('active');
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };


  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.








// **********************************************
// ACF Google Maps Function
// ***********************************************
(function($) {



// Map Styles
 
 var styles = [
 {
  stylers:[
  { saturation: -100,}
  ]
 }];


/*
*  render_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type  function
*  @date  8/11/2013
*  @since 4.3.0
*
*  @param $el (jQuery element)
*  @return  n/a
*/




function render_map( $el ) {

  // var
  var $markers = $el.find('.marker');

  // vars
  var args = {
    zoom    : 16,
    center    : new google.maps.LatLng(0, 0),
    mapTypeId : google.maps.MapTypeId.ROADMAP

  };

  // create map           
  var map = new google.maps.Map( $el[0], args);
  map.setOptions({styles: styles});

  // add a markers reference
  map.markers = [];

  // add markers
  $markers.each(function(){

      add_marker( $(this), map );

  });

  // center map
  center_map( map );

}

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type  function
*  @date  8/11/2013
*  @since 4.3.0
*
*  @param $marker (jQuery element)
*  @param map (Google Map object)
*  @return  n/a
*/

function add_marker( $marker, map ) {

  // var
  var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

  // create marker
  var marker = new google.maps.Marker({
    position  : latlng,
    map     : map
  });

  // add to array
  map.markers.push( marker );

  // if marker contains HTML, add it to an infoWindow
  if( $marker.html() )
  {
    // create info window
    var infowindow = new google.maps.InfoWindow({
      content   : $marker.html()
    });

    // show info window when marker is clicked
    google.maps.event.addListener(marker, 'click', function() {

      infowindow.open( map, marker );

    });
  }

}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type  function
*  @date  8/11/2013
*  @since 4.3.0
*
*  @param map (Google Map object)
*  @return  n/a
*/

function center_map( map ) {

  // vars
  var bounds = new google.maps.LatLngBounds();

  // loop through all markers and create bounds
  $.each( map.markers, function( i, marker ){

    var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

    bounds.extend( latlng );

  });

  // only 1 marker?
  if( map.markers.length == 1 )
  {
    // set center of map
      map.setCenter( bounds.getCenter() );
      map.setZoom( 16 );
  }
  else
  {
    // fit to bounds
    map.fitBounds( bounds );
  }

}

/*
*  document ready
*
*  This function will render each map when the document is ready (page has loaded)
*
*  @type  function
*  @date  8/11/2013
*  @since 5.0.0
*
*  @param n/a
*  @return  n/a
*/





$(document).ready(function(){

  $('.acf-map').each(function(){

    render_map( $(this) );

  });

});

})(jQuery);


// Google map styles
// 
// 


  (function($){

    var slideController = function(event) {

  var master = this;
  var runner = {};
  var action, prevent, alwaysOpen, $cntnr, $group, $open;

/* ==========================================================================
  Get Some Vars
  ========================================================================= */

  // .is() over .hasClass() for SVG support :(
  action = $(this).is(".slider-trigger") ? "toggleClass" : false;
  action = !action && $(this).is(".slider-close") ? "removeClass" : action;
  action = !action && $(this).is(".slider-open") ? "addClass" : action;

  $cntnr = $(this).data("slider-cntnr") ? $( $(this).data("slider-cntnr") ) : $(this).closest(".slider-group");
  $group = $cntnr.data("group") ? $( $cntnr.data("group") ) : false;

  prevent    = $cntnr.is("[data-no-prevent]") ? false : true;
  alwaysOpen = $cntnr.is("[data-always-open]") ? true : false;

/* ==========================================================================
  Transition Detection
  ========================================================================= */

  function whichTransitionEvent(){
    var t,
      el = document.createElement("fakeelement");

    var transitions = {
      "transition"      : "transitionend",
      "OTransition"     : "oTransitionEnd",
      "MozTransition"   : "transitionend",
      "WebkitTransition": "webkitTransitionEnd"
    }

    for (t in transitions){
      if (el.style[t] !== undefined){
        return transitions[t];
      }
    }
  }

  var transitionEvent = whichTransitionEvent();

/* ==========================================================================
  Runner
  ========================================================================= */

  runner.run = function($cntnr, action) {

    var self = this;
  
/* ==========================================================================
  Var Setup
  ========================================================================= */

    this.action  = action;
    this.prevent = prevent;
    this.$cntnr  = $cntnr;
    this.type    = this.$cntnr.data("slide");
    this.$target = this.$cntnr.find("> .slider-target");

/* ==========================================================================
  Make a Clone for Size Comparisons
  ========================================================================= */

    this.makeClone = function() {
      self.$clone = self.$cntnr.clone();
      self.$clone.css({
        display:    'block',
        position:   'fixed',
        visibility: 'hidden',
      });

      self.$clone.appendTo("body");
      self.$cloneTarget = self.$clone.find(".slider-target");
    };

/* ==========================================================================
  Animation Types
  ========================================================================= */

    this.vertical = function() {
      // First explicitly set our current height
      self.$target.height(self.$cloneTarget.outerHeight());
      
      self.$clone.css({
        width: self.$cntnr.width(),
      });

      // Then toggle the class, and set our new height
      self.$clone[self.action]("open");
      var height = self.$cloneTarget.outerHeight();
      self.$target.height(height);
    };

    this.horizontal = function() {
      // First explicitly set our current width
      self.$target.width(self.$cloneTarget.outerWidth());
      
      // Then toggle the class, and set our new width
      self.$clone[self.action]("open");
      var width = self.$cloneTarget.outerWidth();
      self.$target.width(width);
    };

/* ==========================================================================
  Callable Funcs
  ========================================================================= */

    this.toggle = function() {
      self.$cntnr.toggleClass("open");
    };

    this.open = function() {
      self.$cntnr.addClass("open");
    };

    this.close = function() {
      self.$cntnr.removeClass("open");
    };

/* ==========================================================================
  Utility
  ========================================================================= */

    this.cleanup = function() {
      self.$clone.remove();
    };

/* ==========================================================================
  Do the thing.
  ========================================================================= */

    this.prevent && event.preventDefault();

    self.$target.one(transitionEvent, function(event) {
      $(this).removeClass("animating").removeAttr("style");
    });

    this.makeClone();
    this.$target.addClass("animating");
    this[this.type].call();

    this.$cntnr[self.action]("open");
    this.$cntnr.trigger(self.action, [this.$target]);

    this.cleanup();

  };

/* ==========================================================================
  Do the Things
  ========================================================================= */

  if ($group) {

    var $open = $group.find(".open");
    if (alwaysOpen) {
      if ($open.length && $open.get(0) !== $cntnr.get(0)) {
        runner.run($cntnr, action);
        runner.run($open, "removeClass");
      }
    } else {
      if ($open.length && $open.get(0) !== $cntnr.get(0)) {
        runner.run($open, "removeClass");
      } 
      runner.run($cntnr, action);
    }

  } else {
    runner.run($cntnr, action);
  }
};

$(".slider-trigger").on("click", slideController);
$(".slider-close").on("click", slideController);
$(".slider-open").on("click", slideController);

  })(jQuery);

  // File Upload Bootstrap Extension -- http://jasny.github.io/bootstrap/
!function($){var Fileupload=function(element,options){this.$element=$(element);this.type=this.$element.data("uploadtype")||(this.$element.find(".thumbnail").length>0?"image":"file");this.$input=this.$element.find(":file");if(this.$input.length===0){return}this.name=this.$input.attr("name")||options.name;this.$hidden=this.$element.find('input[type=hidden][name="'+this.name+'"]');if(this.$hidden.length===0){this.$hidden=$('<input type="hidden" />');this.$element.prepend(this.$hidden)}this.$preview=this.$element.find(".fileupload-preview");var height=this.$preview.css("height");if(this.$preview.css("display")!="inline"&&height!="0px"&&height!="none"){this.$preview.css("line-height",height)}this.original={exists:this.$element.hasClass("fileupload-exists"),preview:this.$preview.html(),hiddenVal:this.$hidden.val()};this.$remove=this.$element.find('[data-dismiss="fileupload"]');this.$element.find('[data-trigger="fileupload"]').on("click.fileupload",$.proxy(this.trigger,this));this.listen()};Fileupload.prototype={listen:function(){this.$input.on("change.fileupload",$.proxy(this.change,this));$(this.$input[0].form).on("reset.fileupload",$.proxy(this.reset,this));if(this.$remove){this.$remove.on("click.fileupload",$.proxy(this.clear,this))}},change:function(e,invoked){if(invoked==="clear"){return}var file=e.target.files!==undefined?e.target.files[0]:(e.target.value?{name:e.target.value.replace(/^.+\\/,"")}:null);if(!file){this.clear();return}this.$hidden.val("");this.$hidden.attr("name","");this.$input.attr("name",this.name);if(this.type==="image"&&this.$preview.length>0&&(typeof file.type!=="undefined"?file.type.match("image.*"):file.name.match(/\.(gif|png|jpe?g)$/i))&&typeof FileReader!=="undefined"){var reader=new FileReader();var preview=this.$preview;var element=this.$element;reader.onload=function(e){preview.html('<img src="'+e.target.result+'" '+(preview.css("max-height")!="none"?'style="max-height: '+preview.css("max-height")+';"':"")+" />");element.addClass("fileupload-exists").removeClass("fileupload-new")};reader.readAsDataURL(file)}else{this.$preview.text(file.name);this.$element.addClass("fileupload-exists").removeClass("fileupload-new")}},clear:function(e){this.$hidden.val("");this.$hidden.attr("name",this.name);this.$input.attr("name","");if(navigator.userAgent.match(/msie/i)){var inputClone=this.$input.clone(true);this.$input.after(inputClone);this.$input.remove();this.$input=inputClone}else{this.$input.val("")}this.$preview.html("");this.$element.addClass("fileupload-new").removeClass("fileupload-exists");if(e){this.$input.trigger("change",["clear"]);e.preventDefault()}},reset:function(e){this.clear();this.$hidden.val(this.original.hiddenVal);this.$preview.html(this.original.preview);if(this.original.exists){this.$element.addClass("fileupload-exists").removeClass("fileupload-new")}else{this.$element.addClass("fileupload-new").removeClass("fileupload-exists")}},trigger:function(e){this.$input.trigger("click");e.preventDefault()}};$.fn.fileupload=function(options){return this.each(function(){var $this=$(this),data=$this.data("fileupload");if(!data){$this.data("fileupload",(data=new Fileupload(this,options)))}if(typeof options=="string"){data[options]()}})};$.fn.fileupload.Constructor=Fileupload;$(document).on("click.fileupload.data-api",'[data-provides="fileupload"]',function(e){var $this=$(this);if($this.data("fileupload")){return}$this.fileupload($this.data());var $target=$(e.target).closest('[data-dismiss="fileupload"],[data-trigger="fileupload"]');if($target.length>0){$target.trigger("click.fileupload");e.preventDefault()}})}(window.jQuery);


